// extracted by mini-css-extract-plugin
module.exports = {"container":"ellipsedTextWithToggle_container__80PIp","button":"ellipsedTextWithToggle_button__vyKo6"};